import * as React from "react"
import LeadForm from "../dto/LeadForm";
import SiteData from "../../../../model/site/SiteData";
import AddLeadFormBody from "./AddLeadFormBody";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import User from "../../../../model/user/User";
import {none, option, Option} from "ts-option";
import LeadData from "../../../../model/lead/LeadData";
import Appointment from "../../../../model/appointment/Appointment";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {BaseFormViewProps, BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";

interface ComponentProps {
	/**
	 * On submit callback.
	 */
	onSubmit?: (leadData: LeadData,
		siteData: Option<SiteData>,
		watchers: string[],
		appointments: Option<Appointment[]>,
		agentId: Option<string>) => void;
}

interface ReduxProps {
	/**
	 * Logged in user detail
	 */
	user: User;
}

type Props = ComponentProps & ReduxProps & BaseFormViewProps;

interface IState {
	/**
	 * Array of appointments to create
	 */
	appointmentsToCreate: Option<Appointment[]>
}

type State = IState & BaseFormViewState<LeadForm>

/**
 * Add new lead form view.
 */
class AddLeadFormView extends BaseFormView<LeadForm, Props, State> {
	constructor(props: Props) {
		super(props);
		const agentId = this.props.user.isAgent() ? option(this.props.user.id) : none;
		const form = LeadForm.createEmpty(agentId);
		this.state = {
			form: form,
			shouldValidate: false,
			isFormDirty: false,
			appointmentsToCreate: none
		};
		this.submitForm = this.submitForm.bind(this);
		this.onFieldChanged = this.onFieldChanged.bind(this);
		this.onFieldCompleted = this.onFieldCompleted.bind(this);
		this.onFocusChange = this.onFocusChange.bind(this)
	}

	render() {
		return (
			<React.Fragment>
				<AddLeadFormBody form={this.state.form}
								 onFieldChange={this.onFieldChanged}
								 onFieldCompleted={this.onFieldCompleted}
								 onFocusChange={this.onFocusChange}
								 onFieldsChange={this.onFieldsChanged}
								 appointmentsToCreate={this.state.appointmentsToCreate}
								 onAppointmentsChange={(appointmentsToCreate) => {this.setState({appointmentsToCreate})}}/>
				<FormButtonsView align={"right"}>
					<ButtonPrimary label={"Save"}
								   onClick={this.submitForm}
								   isLoading={this.props.isLoading}
								   disabled={this.props.isLoading}/>
				</FormButtonsView>
			</React.Fragment>
		)
	}

	submitForm() {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid((leadData, siteData, watchers, agentId) => {
				this.props.onSubmit(leadData, siteData, watchers, this.state.appointmentsToCreate, agentId);
			});
		});
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user.get
	}
}

export default connect(mapStateToProps)(AddLeadFormView)